import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import {BehaviorSubject, Observable} from 'rxjs';
import {retry} from 'rxjs/operators';
import {FusionAuthService} from '../../../shared/services/fusion-auth';
import {UrlProviderService} from '../../../shared/services/general';
import {SECURED_STORE} from '../../../shared/utils';
import {Medication} from '../models/common';
import {SearchableService} from './searchable.service';

@Injectable()
export class MedicationService implements SearchableService {
  constructor(
    private urlProvider: UrlProviderService,
    private httpClient: HttpClient,
    private router: Router,
    private fusionAuthService: FusionAuthService
  ) {
    this.customStore = this.customStore.bind(this);
  }

  public search(value: any): Observable<Medication> {
    const filter = JSON.stringify(['code', '=', value]);
    return this.httpClient.get<Medication>(`${this.urlProvider.ApiUrl}/v2/medications/remote-operations?filter=${filter}`)
      .pipe(retry(2));
  }

  public customStore(dataSource: BehaviorSubject<DataSource>): CustomStore {
    return SECURED_STORE({
      loadUrl: `${this.urlProvider.ApiUrl}/v2/medications/remote-operations`,
      routerService: this.router,
      dataSource,
      loadParams: null,
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT()
    });
  }

  public customStoreFilteredByPatientId(patientId: number, dataSource: BehaviorSubject<DataSource>): CustomStore {
    return SECURED_STORE({
      loadUrl: `${this.urlProvider.ApiUrl}/v2/medications/remote-operations/filter-by-patient-id?patientId=${patientId}`,
      routerService: this.router,
      dataSource,
      loadParams: null,
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT()
    });
  }
}
